import React, {useState} from 'react';
import { Box, Typography, Switch, Button, Slide, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, ListItemButton, ListItemIcon, Tooltip, useMediaQuery } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { defaultStorage } from '../../utils/useLocalStorage';

const Transition = React.forwardRef((props, ref) => <Slide direction='down' ref={ref} {...props} />);

export const SettingsModal = ({appSettings, setAppSettings}) => {
  const is_desktop = useMediaQuery('(min-width:600px)', { noSsr: true });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const clickOpenModal = () => setIsOpenModal(true);
  const clickCloseModal = () => setIsOpenModal(false);
  const clickDefault = () => setAppSettings(defaultStorage);
  const handleChange = (e) => setAppSettings({ ...appSettings, 'mTime': Date.now(), [e.target.name]: e.target.checked });
  return (
    <>
    <ListItem key={'settings'} disablePadding sx={{ display: 'block' }}>
      <ListItemButton sx={{ minHeight: 48, justifyContent: 'center', px: 2.5 }} onClick={clickOpenModal}>
        <Tooltip title={`Settings`} placement='right'>
          <ListItemIcon sx={{minWidth: 0, mr: 'auto', justifyContent: 'center'}}>
            <SettingsIcon />
          </ListItemIcon>
        </Tooltip>
      </ListItemButton>
    </ListItem>
    <Dialog fullWidth={true} maxWidth='xs' open={isOpenModal} TransitionComponent={Transition} onClose={clickCloseModal} aria-describedby='settings-dialog'>
      <DialogTitle>{'Settings'}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: is_desktop === true ? 'row' : 'column', alignItems: 'flex-start', justifyContent: 'space-around', m: 0, py: is_desktop === true ? 2 : 0, px: 2}}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', m: 0, py: 0, px: 0, width: '100%'}}>
          <Typography>Desktop</Typography>
          <Typography><Switch onChange={handleChange} checked={appSettings.nPrime} name="nPrime"/>Service</Typography>
          <Typography><Switch onChange={handleChange} checked={appSettings.nTeam} name="nTeam"/>Group</Typography>
          <Typography><Switch onChange={handleChange} checked={appSettings.nDirect} name="nDirect"/>Direct</Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', m: 0, py: 0, px: 0, width: '100%'}}>
          <Typography>Sound</Typography>
          <Typography><Switch onChange={handleChange} checked={appSettings.sPrime} name="sPrime"/>Service</Typography>
          <Typography><Switch onChange={handleChange} checked={appSettings.sTeam} name="sTeam"/>Group</Typography>
          <Typography><Switch onChange={handleChange} checked={appSettings.sDirect} name="sDirect"/>Direct</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', flexDirection: 'row', m: 0, py: 2, px: 2}}>
        <Typography><Switch onChange={handleChange} checked={appSettings.debug} name="debug" color="warning"/>Debug</Typography>
        <Box sx={{display: 'flex', flexGrow: 1}} />
        <Button variant='outlined' onClick={clickDefault} color='warning'>{'Default'}</Button>
        <Button variant='text' onClick={clickCloseModal}>{'Close'}</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};